import {Material} from '@wonderlandengine/api';
import {YogaNodeProps} from '@wonderlandengine/react-ui';
import {Container, Image, Panel, Panel9Slice} from '@wonderlandengine/react-ui/components';
import React, {useMemo} from 'react';
import {
    RotBHudMaterialContextValue,
    RotBMaterialContextValue,
    useRotBMaterialContext,
} from '../utils/rotb-material-context.js';
import {colorSwatch} from '../utils/colorSwatch.js';
import {Color, parseColor} from '../utils/utils.js';
import {UIColorTextured} from '../../types/materials.js';

export const Window = (
    props: React.PropsWithChildren<YogaNodeProps> & {
        shadowMaterial?: Material;
        material?: Material;
        gradientMaterial?: Material;
        color?: Color;
    }
) => {
    const rotbMats = useRotBMaterialContext() as RotBMaterialContextValue;

    let material = props.material ?? rotbMats?.windowMaterial;

    const bm = useMemo(() => material!.clone(), []);
    (bm as UIColorTextured).setColor(parseColor(props.color ?? colorSwatch.Window));

    const shadowMaterial = props.shadowMaterial ?? rotbMats?.windowShadowMaterial;
    const gradientMaterial = props.gradientMaterial ?? rotbMats?.gradientMaterial;
    (gradientMaterial as any).setColor(parseColor(colorSwatch.WindowGradient));

    return (
        <Container {...props}>
            <Panel9Slice
                width={props.width ?? 570}
                height={props.height ?? 780}
                borderSize={5}
                material={shadowMaterial}
                borderTextureSize={9 / 64}
            >
                <Panel9Slice
                    left={-4}
                    top={-4}
                    width={props.width ?? 570}
                    height={props.height ?? 780}
                    borderSize={5}
                    material={bm}
                    borderTextureSize={9 / 64}
                    padding={5}
                >
                    <Panel
                        width="100%"
                        height="100%"
                        rounding={0}
                        material={gradientMaterial}
                    >
                        {props.children}
                    </Panel>
                </Panel9Slice>
            </Panel9Slice>
        </Container>
    );
};
